import { MonthlyReportData } from '../Components/MonthlyReports/MonthlyReports';
import { BASE_PATH } from '../__mocks__/api';

export const postMonthlyData = async (
  requestObj: MonthlyReportData | undefined,
  customerId: any,
): Promise<MonthlyReportData> => {
  let fetchUrl = `${BASE_PATH}/autostat/${customerId}`;

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestObj),
  };

  return await (await fetch(fetchUrl, requestOptions)).json();
};

export const getMonthlyData = async (customerId: any): Promise<MonthlyReportData> => {
  let fetchUrl = `${BASE_PATH}/autostat/${customerId}`;

  const requestOptions = {
    method: 'GET',
  };

  return await (await fetch(fetchUrl, requestOptions)).json();
};
